module.exports = __webpack_public_path__ + "img/logo.3eee2a2d.png";